import React, { FC, ReactNode } from "react";

import classnames from "classnames";
import { twMerge } from "tailwind-merge";

export interface StepsProps {
  children: ReactNode;
  orientation?: "horizontal" | "vertical";
}

export interface StepProps {
  children: ReactNode;
  completed?: boolean;
  dataContent?: string;
}

/**
 * Cobalt Steps container - Based on DaisyUI steps classes
 * @see https://daisyui.com/components/steps/
 */
export const Steps: FC<StepsProps> = ({ children, orientation = "horizontal" }) => {
  return <ul className={twMerge("si-steps", classnames({ "si-steps-vertical": orientation === "vertical" }), "w-full", "pl-0")}>{children}</ul>;
};

/**
 * Cobalt Step item - to be used inside <Steps>
 */
export const Step: FC<StepProps> = ({ children, completed, dataContent }) => {
  const content = dataContent ?? null;
  return (
    <li data-content={content} className={twMerge(classnames("si-step", completed ? "si-step-primary" : null))}>
      {children}
    </li>
  );
};

export default Steps;
